import { useEffect, useRef } from "react";
import { get_user_active_call } from "../api/CallControlApi";

const POLL_INTERVAL_MS = 3000;

/**
 * Poll Redis-backed active call state for Zoom embedded panels where WebSocket
 * events may be missed.
 */
export function useZoomActiveCallPolling({
  enabled,
  callEvent,
  formSubmitted,
  setCallEvent,
  setCallInfo,
  setFormSubmitted,
}) {
  const callEventRef = useRef(callEvent);
  const formSubmittedRef = useRef(formSubmitted);

  useEffect(() => {
    callEventRef.current = callEvent;
  }, [callEvent]);

  useEffect(() => {
    formSubmittedRef.current = formSubmitted;
  }, [formSubmitted]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const poll = async () => {
      try {
        const response = await get_user_active_call();
        if (response?.message !== "ACTIVE" || !response?.data?.engagement_id) {
          return;
        }

        const engagementId = response.data.engagement_id;
        const currentEvent = callEventRef.current;

        if (currentEvent === "ENDED" && !formSubmittedRef.current) {
          return;
        }

        setCallInfo((prev) => {
          if (prev?.engagement_id === engagementId) {
            return { ...prev, ...response.data };
          }
          return response.data;
        });

        if (currentEvent === "IDLE" || currentEvent === "ANSWERED") {
          setFormSubmitted(false);
          setCallEvent("ANSWERED");
        }
      } catch (error) {
        console.error("Active call poll failed:", error);
      }
    };

    poll();
    const intervalId = setInterval(poll, POLL_INTERVAL_MS);
    return () => clearInterval(intervalId);
  }, [enabled, setCallEvent, setCallInfo, setFormSubmitted]);
}
